'use client';

import { Icon, type IconProps } from '@iconify/react';
import NoSsr from '@mui/material/NoSsr';
import { styled, type SxProps, type Theme } from '@mui/material/styles';
import { mergeClasses } from 'minimal-shared/utils';
import { forwardRef } from 'react';

import { iconifyClasses } from './classes';
import { registerMetricCardOfflineIcons } from './register-metric-card-offline-icons';

registerMetricCardOfflineIcons();

// ----------------------------------------------------------------------

export type IconifyProps = React.ComponentProps<typeof IconRoot> & IconProps;

export const Iconify = forwardRef<SVGSVGElement, IconifyProps>((props, ref) => {
  const { className, width = 20, sx, ...other } = props;

  const baseStyles: SxProps<Theme> = {
    width,
    height: width,
    flexShrink: 0,
    display: 'inline-flex',
  };

  const renderFallback = () => (
    <IconFallback
      className={mergeClasses([iconifyClasses.root, className])}
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      sx={[baseStyles, ...(Array.isArray(sx) ? sx : [sx])]}
    />
  );

  return (
    <NoSsr fallback={renderFallback()}>
      <IconRoot
        ssr
        ref={ref}
        className={mergeClasses([iconifyClasses.root, className])}
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        sx={[baseStyles, ...(Array.isArray(sx) ? sx : [sx])]}
        {...other}
      />
    </NoSsr>
  );
});
Iconify.displayName = 'Iconify';

// https://iconify.design/docs/iconify-icon/disable-cache.html
// disableCache('local');

// ----------------------------------------------------------------------

const IconRoot = styled(Icon)``;

const IconFallback = styled('span')``;
